import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import RegisterUser from './components/RegisterUser';
import UserLogin from './components/UserLogin';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import { UserProvider } from './context/UserContext';
import TestScreen  from './components/TestScreen'; // Import the new TestScreen component
import TestContent from './components/TestContent';

import './App.css';

function App() {
    return (
        <UserProvider>
        <Router>
            <div className="App">
                <h1>CHAMP - Cognitive Home Assessment and Monitoring Platform</h1>

                <nav>
                    <Link to="/">Login</Link> |{' '}
                    <Link to="/register">Register</Link> |{' '}
                    <Link to="/forgot-password">Forgot Password</Link>
                </nav>
                <Routes>
                    <Route path="/" element={<UserLogin />} />
                    <Route path="/register" element={<RegisterUser />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/testscreen" element={<TestScreen />} />
                    <Route path="/test-content" element={<TestContent />} />

                </Routes>

                <a href="https://www.nubellum.com" >Copyright (c) 2025 By Nubellum Research</a>

            </div>
          </Router>
        </UserProvider>
    );
}

export default App;
